import isEmpty from 'lodash/isEmpty';
import template from './select.html';

class selectSchoolCommonRoomComponent {
  /** @ngInject */
  constructor(
    $log, $rootScope, $state, $mdDialog, $window, $location, $stateParams,
    SchoolCommonRoomService,
    ClassRoomService
  ) {
    this.$log = $log;
    this.$rootScope = $rootScope;
    this.$state = $state;
    this.$mdDialog = $mdDialog;
    this.$window = $window;
    this.$location = $location;
    this.$stateParams = $stateParams;
    this.SchoolCommonRoomService = SchoolCommonRoomService;
    this.ClassRoomService = ClassRoomService;
    this.show = false;
    this.allClassRooms = [];
  }

  $onChanges(changes) {
    if (changes.schoolCommonRooms) {
      this.schoolCommonRooms = Object.assign([], this.schoolCommonRooms);
    }

    if (changes.currentSchoolCommonRoom) {
      this.currentSchoolCommonRoom = {...this.currentSchoolCommonRoom};
    }

    if (changes.currentClassRoom) {
      this.currentClassRoom = {...this.currentClassRoom};
    }
  }

  $onInit() {
    if (!isEmpty(this.currentSchoolCommonRoom)) {
      this.selectedSchoolCommonRoom = this.currentSchoolCommonRoom;
    }

    // To raczej zbędne if (!isEmpty(this.currentClassRoom)) {
    //   this.currentClassRoom = this.currentClassRoom;
    // }

    if (this.schoolCommonRooms.length === 0) {
      this.$window.location.href = this.$location.protocol() + '://' + this.$location.host() + '/interfejs_lekcyjny';
      return false;
    }

    if (this.schoolCommonRooms.length > 1 || !this.schoolCommonRooms[0].configurationCompleted) {
      this.show = true;
    }

    if (this.schoolCommonRooms.length === 1) {
      this.selectedSchoolCommonRoom = this.schoolCommonRooms[0];
      if (!this.selectedSchoolCommonRoom.configurationCompleted) {
        this.SchoolCommonRoomService.getMe().then(me => {
          if (me.roleName !== 'MANAGER') {
            this.$mdDialog.show(
              this.$mdDialog.alert()
                .clickOutsideToClose(true)
                .title('Brak skonfigurowanych świetlic')
                .textContent(`Żadna z świetlic, do których należysz nie została
                  jeszcze skonfigurowana. Skontaktuj się z kierownikiem w celu
                  konfiguracji świetlicy. Możesz pracować tylko na skonfigurowanej świetlicy.`)
                .ariaLabel('Nieskonfigurowana świetlica. Skontaktuj się z kierownikiem świetlicy.')
                .ok('Zamknij i wróć')
            ).then(() => {
              this.$window.location.href = this.$location.protocol() + '://' + this.$location.host() + '/interfejs_lekcyjny';
            });
          }
        });
      }

      this.ClassRoomService.getClassRooms(true, this.selectedSchoolCommonRoom.id).then(result => {
        this.classRooms = result;
        if (result && result.length > 1) {
          this.show = true;
        }
      });
    }
  }

  changeClassRoom(classRoom) {
    this.ClassRoomService.setCurrentClassRoom(classRoom);
    this.$rootScope.$broadcast('layout.header.changeClassRoom');
  }

  loadClassRooms() {
    if (angular.isUndefined(this.selectedSchoolCommonRoom) || angular.isUndefined(this.selectedSchoolCommonRoom.id)) {
      return false;
    }

    this.ClassRoomService.getClassRooms(true, this.selectedSchoolCommonRoom.id).then(result => {
      this.classRooms = result;
      if (result.length > 0) {
        angular.copy(result, this.allClassRooms);
        this.selectedClassRoom = this.classRooms[0];
      }
    });
  }

  open(ev) {
    if (angular.isUndefined(this.selectedSchoolCommonRoom) || angular.isUndefined(this.selectedSchoolCommonRoom.id)) {
      return false;
    }

    this.show = false;
    this.SchoolCommonRoomService.setMySchoolCommonRoom(this.selectedSchoolCommonRoom);
    this.changeClassRoom(this.selectedClassRoom ? this.selectedClassRoom : this.allClassRooms[0]);
    this.SchoolCommonRoomService.getMe().then(me => {
      if (this.selectedSchoolCommonRoom.configurationCompleted) {
        this.$state.go('modules.dashboard', {}, {reload: true});
      } else if (me.roleName === 'MANAGER') {
        this.$state.go('modules.settings.step1', {}, {reload: true});
      } else {
        this.show = true;
        this.$mdDialog.show(
          this.$mdDialog.alert()
            .clickOutsideToClose(true)
            .title('Nieskonfigurowana świetlica')
            .textContent('Skontaktuj się z kierownikiem w celu konfiguracji świetlicy. Możesz pracować tylko na skonfigurowanej świetlicy.')
            .ariaLabel('Nieskonfigurowana świetlica. Skontaktuj się z kierownikiem świetlicy.')
            .ok('Zamknij')
            .targetEvent(ev)
        );
      }
    })
      .catch(() => {
        this.show = true;
      });
  }
}

export const SelectSchoolCommonRoom = {
  bindings: {
    schoolCommonRooms: '<',
    currentSchoolCommonRoom: '<',
    currentClassRoom: '<'
  },
  template,
  controller: selectSchoolCommonRoomComponent
};
